<p-toolbar>
  <div class="p-toolbar-group-start">
    <button pButton pRipple label="New" icon="pi pi-plus" class="p-button-primary mr-2" (click)="onNewClick()"></button>
  </div>
</p-toolbar>

<p-table #dt
         dataKey="id"         
         [value]="(data$ | async)!"
         [loading]="(isLoading$ | async)!"
         [totalRecords]="(dataCount$ | async)!"
         [lazy]="true"
         [rows]="96"
         [showCurrentPageReport]="true"
         [rowsPerPageOptions]="[10, 25, 50, 96]"
         [paginator]="true"
         [globalFilterFields]="['e.dayOfWeek']"
         [filterDelay]="250"
         [breakpoint]="'960px'"
         [rowHover]="true"
         (onLazyLoad)="onLazyLoad($event)"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
         sortField="e.id"
         sortMode="single"
         responsiveLayout="stack">
  <ng-template pTemplate="caption">
    <div class="flex">
      Short Term Rental Time Slots
      <!-- <span class="p-input-icon-left ml-auto">
        <i class="pi pi-search"></i>
        <input pInputText type="text" placeholder="Search keyword" (input)="applyFilterGlobal($event)" />
      </span> -->
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 15rem">
        <div class="flex align-items-center">
          <!-- <p-tableHeaderCheckbox /> -->
          <span class="first-col">Enabled</span>
        </div>
      </th>
      <th style="min-width:15rem" pSortableColumn="e.dayOfWeek">
        <div class="flex align-items-center">
          Day
          <p-sortIcon field="e.dayOfWeek"></p-sortIcon>
          <p-columnFilter type="text" field="e.dayOfWeek" display="menu" matchMode="equals"></p-columnFilter>
        </div>
      </th>
      <th style="min-width:15rem" pSortableColumn="e.displayTime">
        <div class="flex align-items-center">
          Time
          <p-sortIcon field="e.displayTime"></p-sortIcon>
          <p-columnFilter type="text" field="e.displayTime" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="width: 8rem"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-timeSlot>
    <tr [ngClass]="{'deleted-record': false}">
      <td>
        <p-checkbox [(ngModel)]="timeSlot.enabled" [binary]="true" inputId="binary" (click)="onToggleEnabledClick(timeSlot)" />
      </td>
      <td>
        <span class="p-column-title"><strong>Day</strong></span>
        {{timeSlot.dayOfWeek | weekIdToName}}
      </td>
      <td>
        <span class="p-column-title"><strong>Time</strong></span>
        {{timeSlot.displayTime}}
      </td>
      <td style="text-align: center">
        <button pButton
                pRipple
                icon="pi pi-pencil"
                class="p-button-rounded p-button-primary mr-2"
                (click)="openEntity(timeSlot.id)"
                pTooltip="Edit"
                tooltipPosition="left">
        </button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">No time slots found.</td>
    </tr>
  </ng-template>
</p-table>
